import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "utils/cn";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        warning:
          "border-transparent bg-warning-soft text-warning hover:bg-warning-soft/80",
        success:
          "border-transparent bg-success-soft text-success hover:bg-success-soft/80",
        danger:
          "border-transparent bg-danger-soft text-danger hover:bg-danger-soft/80",
      },
      rounded: {
        default: "rounded-full",
        notched: "rounded-md",
        square: "rounded-none",
      },
    },
    defaultVariants: {
      variant: "default",
      rounded: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, rounded, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, rounded }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
